import { useState } from 'react';
import { useNavigate } from '../lib/routing';
import { HeaderContent, HEADER_TITLE_CLASS } from '../components/shell/app-header';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Buildings } from '@phosphor-icons/react';

const HEADER_ICON = <Buildings size={26} />;
import { createSchool } from '../lib/admin-users';

export default function AdminUsersSchoolCreate() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [directorEmail, setDirectorEmail] = useState('');
  const [department, setDepartment] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    setError(null);
    try {
      await createSchool(name.trim(), directorEmail.trim() || null, department.trim() || null);
      navigate('/admin/users/schools');
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <HeaderContent width="md" showBurger backTo="/admin/users/schools" backLabel="Établissements" icon={HEADER_ICON}>
        <h1 className={HEADER_TITLE_CLASS}>Créer un établissement</h1>
      </HeaderContent>
      <main className="max-w-[600px] mx-auto px-4 pb-16 pt-4">

        {error && (
          <p className="mb-5 px-4 py-3 rounded-[10px] bg-red-50 text-red-700 text-sm font-semibold">{error}</p>
        )}

        <div className="bg-[var(--naia-card)] border border-[var(--naia-line)] rounded-[var(--naia-r-card)] shadow-[var(--naia-shadow-card)] px-6 py-6">
          <form onSubmit={(e) => void onSubmit(e)} className="flex flex-col gap-5">
            <label className="flex flex-col gap-2 text-[12.5px] font-bold text-[var(--naia-text-primary)]">
              Nom de l'établissement <span className="text-red-500">*</span>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Collège Victor Hugo"
                required
                autoFocus
              />
            </label>

            <label className="flex flex-col gap-2 text-[12.5px] font-bold text-[var(--naia-text-primary)]">
              Département
              <Input
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
                placeholder="ex: 75"
                maxLength={3}
              />
              <span className="text-[11.5px] font-normal text-[var(--naia-text-secondary)]">
                Optionnel — utilisé pour générer les identifiants anonymes des élèves.
              </span>
            </label>

            <label className="flex flex-col gap-2 text-[12.5px] font-bold text-[var(--naia-text-primary)]">
              Email du directeur
              <Input
                type="email"
                value={directorEmail}
                onChange={(e) => setDirectorEmail(e.target.value)}
                placeholder="directeur@ecole.fr"
              />
              <span className="text-[11.5px] font-normal text-[var(--naia-text-secondary)]">
                Optionnel — un compte directeur sera créé ou lié automatiquement si fourni.
              </span>
            </label>

            <div className="flex gap-3 pt-1">
              <Button type="submit" disabled={busy || !name.trim()}>
                {busy ? 'Création…' : "Créer l'établissement"}
              </Button>
              <Button type="button" variant="outline" onClick={() => navigate('/admin/users/schools')}>
                Annuler
              </Button>
            </div>
          </form>
        </div>
      </main>
    </>
  );
}
